// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table >>> tbody tr.v-data-table__expanded__content {\n  background: #eeeeee;\n  box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
